import { useEffect, useState } from 'react';

import Portal from '@zenbusiness/zui/Portal';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import PropTypes from 'prop-types';

import { HubContainerGridStyled, HubMainWrapperStyled, FocusGrid } from '#client/components/Grid';

import { StickyBoxStyled } from './styles';

export default function StickyBoxContainer({
  bottomThreshold = 500,
  children,
  isShiftable = false
}) {
  const [isStickyTop, setIsStickyTop] = useState(false);
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  useEffect(() => {
    let animationFrameId;

    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const bottomPosition = document.documentElement.offsetHeight;

      setIsStickyTop(scrollPosition > bottomPosition - bottomThreshold);
    };

    const onScroll = () => {
      if (animationFrameId) {
        return;
      }
      animationFrameId = requestAnimationFrame(() => {
        handleScroll();
        animationFrameId = null;
      });
    };

    if (isShiftable) {
      window.addEventListener('scroll', onScroll);

      // Call the handler immediately to set the initial state
      handleScroll();
    }

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [bottomThreshold, isShiftable]);

  return (
    <Portal>
      <StickyBoxStyled
        isStickyTop={isStickyTop}
        topPosition={isMobile ? 80 : 92}
      >
        <HubContainerGridStyled>
          <FocusGrid>
            <HubMainWrapperStyled>{children}</HubMainWrapperStyled>
          </FocusGrid>
        </HubContainerGridStyled>
      </StickyBoxStyled>
    </Portal>
  );
}

StickyBoxContainer.propTypes = {
  bottomThreshold: PropTypes.number,
  children: PropTypes.node,
  isShiftable: PropTypes.bool
};
